import { DsLanguageMap, DsDropshippingGuideI18nTemplate } from './dsTypes';

export const dsIntroductionTemplate: DsLanguageMap<DsDropshippingGuideI18nTemplate['introduction']> = {
  zh: {
    titleWhatIs: '什么是海外仓一件代发',
    textWhatIsLine1: '海外仓一件代发，是目前最快的跨境履约方式。',
    textWhatIsLine2:
      '通过海运或空运等国际物流方式，提前将大量商品暂存在海外仓。订单产生后，从海外仓发货，2-5天送达顾客。时效和稳定性媲美本土卖家，成本远低于空运小包等传统物流方式。',
    actionShipNow: '立即发货',
    actionOpenAccount: '立即开户',
    actionShippingCalculator: '运费试算',
    logisticsFactory: '工厂',
    logisticsPreparation: '备货',
    logisticsInternational: '国际物流',
    logisticsWarehouse: '海外仓',
    logisticsStorage: '暂存',
    logisticsExpress: '海外快递',
    logisticsCustomer: '顾客',
    logisticsReceive: '收货',
    titleSla: '海海承诺的时效',
    descriptionSla: '以当地时间为准，不含当地法定假期和周六日。',
    sectionInternational: '国际物流',
    metricAirExpressTitle: '空运转快递派送',
    metricAirTruckTitle: '空运转卡车派送',
    metricSeaExpressTitle: '海运转快递派送',
    metricSeaTruckTitle: '海运转卡车派送',
    metricInternationalDescriptionAirportPrefix: '从离开中国机场，到',
    metricInternationalDescriptionPortPrefix: '从离开中国港口，到',
    metricInternationalDescriptionSuffix: '收货。',
    sectionWarehouse: '海外仓',
    metricInboundTitle: '入库',
    metricInboundDescription: '从海外仓收货到商品可用。',
    metricOutboundTitle: '出库',
    metricOutboundDescription: '从提交入库单到商品出库，工作日上午11:00前的入库单最快当天出库。',
    sectionExpress: '海外快递',
    metricDeliveryTitle: '上网和送达',
    metricDeliveryValue: '免费补发',
    metricDeliveryBadge: '无轨迹',
    metricDeliveryDescription:
      '海海和电商平台销售的快递产品均可满足平台的时效要求。但上网和送达时间以实际物流轨迹为准，我们无法做出保证，但可以协助补发。如遇无轨迹情况，可申请免费补发。',
    titleCompensation: '海海可以赔付的事项',
    descriptionCompensation: '60天内向海海客服提出申请，赔付金额将充值至OMS。',
    sectionCompInternational: '国际物流',
    compLostGoodsTitle: '国际物流丢件',
    compLostGoodsCollapsedValue: '≤申报价或物流费2倍',
    compLostGoodsNote: '如果海外快递系统显示已签收，但海外仓实际未收到，也视为在海外快递运输途中丢件。',
    compLostGoodsDescription:
      '如果商品已被集货仓签收，在送达海外仓前丢失，我们将按申报价格承担对应商品的赔偿责任。在海外快递运输途中丢件，赔偿金额不超过100美元；在其他环节丢件，赔偿金额不超过该笔国际物流费用的2倍。',
    compSeizedGoodsTitle: '国际物流扣货',
    compSeizedGoodsCollapsedValue: '≤申报价或物流费2倍',
    compSeizedGoodsDescription:
      '如果你的商品和申报信息完全合规，因我们的过错被监管部门查没，我们将按申报价格承担对应商品的赔偿责任，赔偿金额不超过该笔国际物流费用的2倍。',
    compWarehouseDelayInboundTitle: '海外仓延迟入库',
    compWarehouseDelayInboundCollapsedValue: '0.5元/KG/天',
    compWarehouseDelayInboundNote: '此项赔偿不适用于在国际物流环节丢件或被扣货的商品。',
    compWarehouseDelayInboundDescription:
      '如果商品未在承诺时间内送达海外仓或上架（以OMS记录时间为准），并对你造成损失，我们将按0.5元人民币/KG/天承担国际物流的赔偿责任，赔偿金额不超过该笔国际物流费用。',
    sectionCompWarehouse: '海外仓',
    compWarehouseDelayOutboundTitle: '海外仓延迟出库',
    compWarehouseDelayOutboundCollapsedValue: '40元/订单',
    compWarehouseDelayOutboundDescription:
      '一件代发时，如果订单未在承诺时间内出库（以OMS记录时间为准），导致你被电商平台处罚，我们将按40元人民币/订单承担赔偿责任。',
    compWarehouseWrongShipmentTitle: '海外仓错发商品',
    compWarehouseWrongShipmentCollapsedValue: '≤零售价20%',
    compWarehouseWrongShipmentDescription:
      '一件代发时，如果出现了错发、漏发的情况，我们将全额承担对应海外快递的赔偿责任。如果商品无法追回，还将按申报价格承担对应商品的赔偿责任，赔偿金额不超过商品零售价格的20%。',
    compWarehouseDamageTitle: '海外仓损毁商品',
    compWarehouseDamageCollapsedValue: '≤零售价20%',
    compWarehouseDamageDescription:
      '如果商品入库后按你的要求进行了逐件清点，后续发现丢失或损坏，我们将按申报价格承担对应商品的赔偿责任，赔偿金额不超过商品零售价格的20%。',
    sectionCompExpress: '海外快递',
    compFakeLabelTitle: '海外快递虚假面单',
    compFakeLabelCollapsedValue: '面单售价2倍',
    compFakeLabelDescription:
      '如果你通过海海购买的面单被快递公司判定为虚假且申诉无效，我们将按面单售价2倍的标准承担对应海外快递的赔偿责任。',
    titleAssistance: '海海可以协助的事项',
    descriptionAssistance: '遇到以下情况时，我们将协助你处理，但不在赔偿范围内。',
    assistNoTrackingTitle: '海外快递无物流轨迹',
    assistNoTrackingDescription:
      '在规定时间内提供物流轨迹是部分电商平台对卖家的要求，不是海外快递公司的义务，任何机构或个人都无法通过合法方式对该时效做出保证。我们可以免费协助你进行补发或催促快递公司，但无法保证结果。',
    assistLostOrDelayedTitle: '海外快递丢件或延误',
    assistLostOrDelayedDescription:
      '海外快递公司的赔偿政策因产品和保险购买情况不同而异，我们可以协助你进行补发或准备索赔材料，但无法替你申请赔偿。',
    titleNoLiability: '海海无法担责的事项',
    descriptionNoLiability: '除以上列明的事项外，其他原因导致的损失均不在我们的赔偿或协助范围内。',
    noLiabilityForceMajeureTitle: '不可抗力',
    noLiabilityForceMajeureDescription: '因自然灾害、政治活动、战争、罢工等不可抗因素造成的损失。',
    noLiabilityUserFaultTitle: '你的过错',
    noLiabilityUserFaultItem1: '商品不合规：侵权、质量问题、资质问题、涉及违禁品或反倾销等。',
    noLiabilityUserFaultItem2: '申报不合规：填写的申报价格、材质、品牌名不正确等。',
    noLiabilityUserFaultItem3: '未按要求操作：打包不规范、OMS操作不规范等。',
    noLiabilityUnclearTitle: '无法判断过错方的损失',
    noLiabilityUnclearDescription: '如：商品在外包装无破损情况下的丢失或损坏。',
    unitDays: '天',
    unitHours: '小时',
    displayLabelPrefix: '中国 - ',
    defaultRegion: '美西',
    freightAir: '空运',
    freightSea: '海运',
    lastmileExpress: '快递',
    lastmileTruck: '卡车',
  },
  en: {
    titleWhatIs: 'What Is Overseas Warehouse Dropshipping',
    textWhatIsLine1: 'Overseas-warehouse dropshipping is one of the fastest cross-border fulfillment models.',
    textWhatIsLine2:
      'By shipping inventory overseas in advance via sea or air freight, orders can be dispatched from local warehouses and delivered in 2-5 days. It offers local-seller-like speed and stability at much lower cost than traditional international parcels.',
    actionShipNow: 'Ship now',
    actionOpenAccount: 'Open account',
    actionShippingCalculator: 'Shipping calculator',
    logisticsFactory: 'Factory',
    logisticsPreparation: 'Stock prep',
    logisticsInternational: 'International logistics',
    logisticsWarehouse: 'Overseas warehouse',
    logisticsStorage: 'Storage',
    logisticsExpress: 'Local delivery',
    logisticsCustomer: 'Customer',
    logisticsReceive: 'Receive',
    titleSla: 'SSEEAA Time Commitments',
    descriptionSla: 'Based on local time; excludes local public holidays and weekends.',
    sectionInternational: 'International logistics',
    metricAirExpressTitle: 'Air to express',
    metricAirTruckTitle: 'Air to truck',
    metricSeaExpressTitle: 'Sea to express',
    metricSeaTruckTitle: 'Sea to truck',
    metricInternationalDescriptionAirportPrefix: 'From departure at a China airport to receiving at ',
    metricInternationalDescriptionPortPrefix: 'From departure at a China port to receiving at ',
    metricInternationalDescriptionSuffix: '.',
    sectionWarehouse: 'Overseas warehouse',
    metricInboundTitle: 'Inbound',
    metricInboundDescription: 'From warehouse receipt to inventory available.',
    metricOutboundTitle: 'Outbound',
    metricOutboundDescription: 'From inbound order submission to outbound dispatch; orders before 11:00 AM on business days may ship the same day.',
    sectionExpress: 'Local delivery',
    metricDeliveryTitle: 'Tracking and delivery',
    metricDeliveryValue: 'Free reship',
    metricDeliveryBadge: 'No tracking',
    metricDeliveryDescription:
      'Carriers offered by SSEEAA and e-commerce platforms can meet platform timing requirements. Actual tracking and delivery time depends on carrier scans; we cannot guarantee it but can assist with reshipments for no-tracking cases.',
    titleCompensation: 'Compensation Coverage',
    descriptionCompensation: 'Submit claims to SSEEAA support within 60 days. Compensation is credited to OMS.',
    sectionCompInternational: 'International logistics',
    compLostGoodsTitle: 'International lost parcel',
    compLostGoodsCollapsedValue: 'Up to declared value or 2x freight',
    compLostGoodsNote: 'If carrier shows delivered but warehouse did not receive, it is treated as in-transit loss in local delivery.',
    compLostGoodsDescription:
      'If goods were signed at consolidation warehouse but lost before overseas warehouse delivery, we compensate based on declared value. For loss in local delivery leg, max compensation is $100; for other legs, max is 2x the related international freight fee.',
    compSeizedGoodsTitle: 'International seizure',
    compSeizedGoodsCollapsedValue: 'Up to declared value or 2x freight',
    compSeizedGoodsDescription:
      'If goods and declaration are fully compliant but seized due to our fault, compensation follows declared value and is capped at 2x the related international freight fee.',
    compWarehouseDelayInboundTitle: 'Delayed inbound shelving',
    compWarehouseDelayInboundCollapsedValue: "¥0.5/KG/day",
    compWarehouseDelayInboundNote: 'This does not apply to goods lost or seized during international logistics.',
    compWarehouseDelayInboundDescription:
      "If goods are not delivered or shelved within committed time (based on OMS timestamps) and this causes loss, compensation is ¥0.5 per KG per day, capped at the related international freight fee.",
    sectionCompWarehouse: 'Overseas warehouse',
    compWarehouseDelayOutboundTitle: 'Delayed outbound',
    compWarehouseDelayOutboundCollapsedValue: '¥40/order',
    compWarehouseDelayOutboundDescription:
      'For dropshipping orders not shipped within committed time (based on OMS timestamps), if platform penalties occur, compensation is ¥40 per order.',
    compWarehouseWrongShipmentTitle: 'Wrong or missing items',
    compWarehouseWrongShipmentCollapsedValue: 'Up to 20% of retail price',
    compWarehouseWrongShipmentDescription:
      'For wrong or missing shipments, we fully cover related local-delivery compensation. If goods cannot be recovered, we also compensate declared item value, capped at 20% of retail price.',
    compWarehouseDamageTitle: 'Warehouse damage/loss',
    compWarehouseDamageCollapsedValue: 'Up to 20% of retail price',
    compWarehouseDamageDescription:
      'If item-by-item checking was requested after inbound and goods are later found lost or damaged, compensation follows declared value, capped at 20% of retail price.',
    sectionCompExpress: 'Local delivery',
    compFakeLabelTitle: 'Fake shipping label',
    compFakeLabelCollapsedValue: '2x label price',
    compFakeLabelDescription:
      'If a label purchased via SSEEAA is judged fake by the carrier and appeal fails, compensation is 2x the label sale price.',
    titleAssistance: 'Assistance Scope',
    descriptionAssistance: 'In these scenarios we provide support, but they are outside compensation coverage.',
    assistNoTrackingTitle: 'No tracking updates',
    assistNoTrackingDescription:
      'Providing tracking scans within a time window is a platform requirement for sellers, not a carrier obligation. No legal channel can guarantee this timing. We can help reship or push carriers at no charge, but cannot guarantee outcomes.',
    assistLostOrDelayedTitle: 'Lost or delayed local delivery',
    assistLostOrDelayedDescription:
      'Carrier compensation policies vary by product and insurance coverage. We can help with reshipment and claim materials, but cannot file compensation claims on your behalf.',
    titleNoLiability: 'Non-liability',
    descriptionNoLiability: 'Losses caused by reasons outside the listed items are not covered for compensation or assistance.',
    noLiabilityForceMajeureTitle: 'Force majeure',
    noLiabilityForceMajeureDescription: 'Losses caused by natural disasters, political events, war, strikes, or similar force majeure factors.',
    noLiabilityUserFaultTitle: 'User-side fault',
    noLiabilityUserFaultItem1: 'Product non-compliance: IP issues, quality issues, qualification issues, prohibited goods, anti-dumping concerns, etc.',
    noLiabilityUserFaultItem2: 'Declaration non-compliance: incorrect declared value, material, brand, etc.',
    noLiabilityUserFaultItem3: 'Operational non-compliance: improper packaging or non-standard OMS operations.',
    noLiabilityUnclearTitle: 'Unclear fault ownership',
    noLiabilityUnclearDescription: 'For example, missing/damaged goods with intact outer packaging.',
    unitDays: 'days',
    unitHours: 'hours',
    displayLabelPrefix: 'China - ',
    defaultRegion: 'US West',
    freightAir: 'Air',
    freightSea: 'Sea',
    lastmileExpress: 'Express',
    lastmileTruck: 'Truck',
  },
};
